import {
  type TypographyStyle,
  TypographyVariantsOptions,
} from '@mui/material/styles'

const fontFamily = '"Geist", "Roboto", "Helvetica", "Arial", sans-serif'

const pxToRem = (px: number, base = 16): string => `${px / base}rem`

const style = (
  weight: number,
  size: number,
  height: number
): TypographyStyle => ({
  fontWeight: weight,
  fontSize: pxToRem(size),
  lineHeight: height,
  fontFamily,
})

export const typography: TypographyVariantsOptions = {
  fontFamily,
  fontSize: 14,
  h1: style(700, 42, 1.167),
  h2: style(700, 32, 1.2),
  h3: style(700, 24, 1.167),
  h4: style(700, 20, 1.235),
  h5: style(700, 18, 1.334),
  h6: undefined,
  subtitle1: style(500, 18, 1.75),
  subtitle2: style(500, 16, 1.57),
  body1: style(400, 16, 1.5),
  body2: style(400, 14, 1.5),
  cta1: style(600, 16, 1.5),
  cta2: style(600, 14, 1.5),
  caption: style(600, 10, 2.66),
  overline: style(400, 12, 1.5),
}
